import React from 'react';
import Navbar from './navbar/Navbar';
import { ErrorBoundary } from "react-error-boundary";
import { useNavigate, Outlet } from 'react-router-dom'; // Import useHistory hook
import AppSidebar from './appsidebar/AppSidebar';
import { SidebarProvider } from "@/components/shadcn/sidebar"

const Layout = ({ children }) => {
    // const role = "Executive";
    const role = 'Advisor';
    const navigate = useNavigate(); // Initialize useHistory hook

    function handleBackToHome() {
        navigate('/'); // Navigate to homepage
    }

    const ErrorFallback = () => {
        return (
            <div className='items-center justify-center w-full min-h-screen text-center'>
                <div className="pt-40">
                    <p className='font-bold text-red-500'>Oups! Une erreur est survenue</p>
                    <button
                        onClick={handleBackToHome}
                        className='px-4 py-2 mt-4 font-bold text-white bg-red-500 rounded hover:bg-red-700'
                    >
                        Retour à l&apos;accueil
                    </button>
                </div>
            </div>
        );
    };

    return (
        <SidebarProvider
            defaultOpen={false}
            style={{
                "--sidebar-width": "16rem",
                "--sidebar-width-icon": "3.5rem",
            }}
        >
            <div className='w-screen'>
            <AppSidebar />

                <Navbar />
                <div className="flex">
                    <ErrorBoundary FallbackComponent={ErrorFallback}>
                        <main className={`w-full pt-14 ${role !== 'Advisor' && 'pl-80'}`}>
                            {children}
                            <Outlet />
                        </main>
                    </ErrorBoundary>
                </div>
            </div>
        </SidebarProvider>
    );
};

export default Layout;
